import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { fromEvent } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";

/**
 * Nest this inside of the kno2-grid to display the search box
 * <kno2-grid>
        <kno2-grid-search [debounceTime]="1000" (searchChange)="onSearchChange($event)"></kno2-grid-search>
 * <kno2-grid>
 */
@Component({
    selector: "kno2-grid-search",
    template: `
        <nb-form-field>
            <input
                #searchInput
                nbInput
                type="text"
                placeholder="Search"
                fieldSize="small" />
            <nb-icon
                nbSuffix
                icon="search-outline"></nb-icon>
        </nb-form-field>
    `,
    standalone: false
})
export class GridSearchComponent implements AfterViewInit {
    @Input() public debounceTime = 500;
    @Output() public searchChange: EventEmitter<string>;
    @ViewChild("searchInput") public searchInput: ElementRef;
    constructor() {
        this.searchChange = new EventEmitter<string>();
    }

    public ngAfterViewInit(): void {
        fromEvent(this.searchInput.nativeElement, "keyup")
            .pipe(debounceTime(this.debounceTime), distinctUntilChanged())
            .subscribe(() => {
                this.searchChange.emit(this.searchInput.nativeElement.value);
            });
    }
}
